/**
 * @fileoverview Service for tenant management
 */
import { apiService } from '../api/apiService';

export const tenantService = {
    /**
     * List all tenants
     * @returns {Promise<Array>} List of tenants
     */
    async listTenants() {
        return apiService.request('/tenants');
    },

    /**
     * Create a new tenant
     * @param {Object} tenantData - Tenant details
     * @returns {Promise<Object>} Created tenant
     */
    async createTenant(tenantData) {
        return apiService.request('/tenants', {
            method: 'POST',
            body: JSON.stringify(tenantData),
        });
    },

    /**
     * Update an existing tenant
     * @param {string} id - Tenant ID
     * @param {Object} tenantData - Updated details
     * @returns {Promise<Object>} Updated tenant
     */
    async updateTenant(id, tenantData) {
        return apiService.request(`/tenants/${id}`, {
            method: 'PUT',
            body: JSON.stringify(tenantData),
        });
    },

    /**
     * Deactivate a tenant
     * @param {string} id - Tenant ID
     * @returns {Promise<Object>} Status message
     */
    async deactivateTenant(id) {
        return apiService.request(`/tenants/${id}`, {
            method: 'DELETE',
        });
    },
};
